// @flow
const asyncAction = (name: string) => ({
	START: `${name}.START`,
	SUCCESS: `${name}.SUCCESS`,
	FAIL: `${name}.FAIL`,
});

export const CHECK_AUTH_STATE = asyncAction('CHECK_AUTH_STATE');
export const LOGIN = asyncAction('LOGIN');
export const LOGOUT = asyncAction('LOGOUT');

export const INIT = asyncAction('INIT');
export const GET_ITEMS = asyncAction('GET_ITEMS');
export const GET_ALL_ITEMS = asyncAction('GET_ALL_ITEMS');

export const GET_ITEM = asyncAction('GET_ITEM');
export const UPDATE_ITEM = asyncAction('UPDATE_ITEM');
export const DELETE_ITEM = asyncAction('DELETE_ITEM');
export const REMOVE_UNSTARRED_ITEM = asyncAction('REMOVE_UNSTARRED_ITEM');

export const GET_CHANNELS = asyncAction('GET_CHANNELS');
export const GET_CHANNEL = asyncAction('GET_CHANNEL');
export const UPDATE_CHANNEL = asyncAction('UPDATE_CHANNEL');
export const DELETE_CHANNEL = asyncAction('DELETE_CHANNEL');

export const CREATE_BACKUP = asyncAction('CREATE_BACKUP');
export const ROLLBACK_TO_BACKUP = asyncAction('ROLLBACK_TO_BACKUP');
export const GET_BACKUP_ITEMS = asyncAction('GET_BACKUP_ITEMS');

export const GET_SETTINGS = asyncAction('GET_SETTINGS');
export const UPDATE_SETTINGS = asyncAction('UPDATE_SETTINGS');

export const GET_AUTO_SYNC_ITEMS = asyncAction('GET_AUTO_SYNC_ITEMS');
export const AUTO_SYNC = asyncAction('AUTO_SYNC');
export const UPDATE_AUTO_SYNC_ITEM = 'UPDATE_AUTO_SYNC_ITEM';

export const TV_BEE_SEARCH_SERIES = asyncAction('TV_BEE_SEARCH_SERIES');
export const TV_BEE_GET_SERIES_DATA = asyncAction('TV_BEE_GET_SERIES_DATA');

export const SET_AUTH_ERROR = 'SET_AUTH_ERROR';
export const SET_AUTH_BUSY_STATE = 'SET_AUTH_BUSY_STATE';
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';

export const SET_POP_UP = 'SET_POP_UP';
export const UPDATE_LOCATION = 'UPDATE_LOCATION';

export const UPLOAD_MEDIA = 'UPLOAD_MEDIA';
export const DELETE_MEDIA = 'DELETE_MEDIA';
